import { Component } from '@opten/compiler/metadata/component';
import { ComponentRef } from '@opten/compiler/metadata/di';
import { switchMap } from 'rxjs/operators';
import { authService, memberStorage, ShopContext } from '../shop/shop-context';

@Component({ className: 'js-shop-sign-out', observe: true })
export class SignOutComponent {
	@ComponentRef(ShopContext) shopContext: ShopContext;

	constructor(private element: HTMLElement) {
		this.element.addEventListener('click', e => this.handleSubmit(e));
	}

	protected handleSubmit(e: Event) {
		e.preventDefault();
		this.shopContext.resetToken();
		memberStorage
			.clearUser()
			.pipe(
				switchMap(() => authService.logout()),
				switchMap(() => this.shopContext.finalizeBasket()),
				switchMap(() => this.shopContext.resetOrders()),
				switchMap(() => this.shopContext.completeContext())
			)
			.subscribe(user => {
				// this.shopContext.finalizeBasket();
				// this.shopContext.resetOrders();
				// const isCustomerArea = document.getElementById('login-modal').getAttribute('data-customer-area');
				// if (isCustomerArea === "True") {
				// 	window.location.reload();
				// } else {
				// 	this.shopContext.onAuthenticationChanged.next(user);
				// }
				// window.location.assign('/');
			});
	}
}
